import React, { createContext, useReducer, useEffect } from "react";

export const ThemeContext = createContext();

// Get initial state from localStorage or default to true
const initialState = { darkMode: JSON.parse(localStorage.getItem("darkMode")) ?? true };
const themeReducer = (state, action) => {
  switch (action.type) {
    case "LIGHTMODE":
      localStorage.setItem("darkMode", JSON.stringify(false)); // Update localStorage
      return { darkMode: false };
    case "DARKMODE":
      localStorage.setItem("darkMode", JSON.stringify(true)); // Update localStorage
      return { darkMode: true };
    default:
      return state;
  }
};

export function ThemeProvider({ children }) {
  const [state, dispatch] = useReducer(themeReducer, initialState);

  // Ensure localStorage updates on first render
  useEffect(() => {
    localStorage.setItem("darkMode", JSON.stringify(state.darkMode));
  }, [state.darkMode]);

  return (
    <ThemeContext.Provider value={{ state, dispatch }}>
      {children}
    </ThemeContext.Provider>
  );
}
